import { Card } from "@mui/material";
function AnalyticsStatisticsCard(props) {

  // const currencyText = (am) => {
  //    let amount = am.toString()
  //  let lastThree = amount.substring(amount.length-3);
  //    let otherNumbers = amount.substring(0,a mount.length-3);
  //   if(otherNumbers != '') lastThree = ',' + lastThree;
  //    let res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
  //   return res;
  //   }


  return (
    <div className="">
      <Card sx={{ minWidth: 200, height: 168 }}>
      <div className="h-full w-full">
      <Card sx={{ height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <div className="flex flex-col items-center justify-center py-6">
          <h2 className="text-xl text-gray-500">{props.headText}</h2>
          {props.headText === 'Enrollements' ? (
            <h2 className="text-3xl mt-3">{props.number}</h2>
          ) : (
            <h2 className="text-3xl mt-3">&#8377;{props?.number?.toLocaleString()}</h2>
          )}
        </div>
      </Card>
    </div>
      </Card>
    </div>
  )
}
export default AnalyticsStatisticsCard;